import { createSelector } from '@reduxjs/toolkit';
import { DefaultRootState } from 'react-redux';
import { selectAll, selectById } from '../reducers/strip.reducer';
import { StripId } from '../types/strip.type';

export const stripStateSelector = ({ strip }: DefaultRootState) => strip;

export const stripsSelector = createSelector(stripStateSelector, selectAll);

export const stripByIdSelector = (id: StripId) =>
  createSelector(stripStateSelector, (state) => selectById(state, id));

export const visibleStripsSelector = createSelector(stripsSelector, (strips) =>
  strips.filter(({ visible }) => visible),
);

export const stripGainSelector = (id: StripId) =>
  createSelector(stripByIdSelector(id), (strip) => (strip ? strip.gain : 1));

export const noiseTagFilterSelector = (id: StripId) =>
  createSelector(
    stripByIdSelector(id),
    (strip) => strip?.noiseTagFilter ?? undefined,
  );
